export default __webpack_public_path__ + "static/media/236.6c29eae0.png";